export default {
  apiKey: "AIzaSyAqYCmIscTphG2FzudyPQop04pBZLGGOJw",
  authDomain: "saints-title-service.firebaseapp.com",
  projectId: "saints-title-service",
  storageBucket: "saints-title-service.appspot.com",
  messagingSenderId: "1066824630088",
  appId: "1:1066824630088:web:fcc25519ea5a33e1873d7d",
  measurementId: "G-82705CDZ5R"
};